// extracted by mini-css-extract-plugin
export var badge = "_sf-4";
export var selected = "_sf-1";
export var selectedOverlay = "_sf-5";
export var thumbnailButton = "_sf-0";
export var thumbnailFallback = "_sf-3";
export var thumbnailImage = "_sf-2";